import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeleteExamMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  poolId: Types.Scalars['ID'];
}>;


export type DeleteExamMutation = { __typename?: 'Mutation', deleteExam?: { __typename?: 'DeleteExamPayload', successful: boolean, exam?: { __typename?: 'Label', id: string } | null, error?: { __typename?: 'MeasuredResponseError', name: string, code: number, message: string } | null } | null };

export const DeleteExamDocument = gql`
    mutation deleteExam($id: ID!, $poolId: ID!) {
  deleteExam(id: $id, poolId: $poolId) {
    successful
    exam {
      id
    }
    error {
      name
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteExamGQL extends Apollo.Mutation<DeleteExamMutation, DeleteExamMutationVariables> {
    document = DeleteExamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }